import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  // For now, we'll use a simple check. In production, implement proper admin authentication
  const isAdmin = localStorage.getItem('adminToken');

  if (!isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;
